module.exports = __webpack_public_path__ + "img/drag.d65a1021.svg";